// Mock data for Shubh Wellness Clinic

export const clinicInfo = {
  name: "Shubh Wellness Clinic",
  phone: "519-748-1333",
  email: "shubhwellness05@gmail.com",
  address: {
    street: "3160 King Street East",
    city: "Kitchener",
    province: "Ontario",
    postalCode: "N2A 1B3",
    full: "3160 King Street East, Kitchener, Ontario N2A 1B3"
  },
  bookingUrl: "http://practice-5f8c304b.clinicsense.com/book/",
  socialMedia: {
    instagram: [
      "https://www.instagram.com/shubh_wellnessclinic",
      "https://www.instagram.com/bollywood_medspa",
      "https://www.instagram.com/bollywood_barbers"
    ],
    tiktok: "https://www.tiktok.com/@shubhwellnessclin"
  }
};

export const services = [
  {
    id: 1,
    name: "Massage Therapy",
    description: "Professional therapeutic massage to relieve tension, reduce stress, and promote overall wellness. Our certified massage therapists use various techniques tailored to your specific needs. Home service available!",
    icon: "Sparkles",
    pricing: [
      { duration: "Swedish Massage Therapy 30 min", price: "$79" },
      { duration: "Swedish Massage Therapy 60 min", price: "$115" },
      { duration: "Swedish Massage Therapy 75 min", price: "$145" },
      { duration: "Swedish Massage Therapy 90 min", price: "$159" },
      { duration: "Deep Tissue Hot Stone Massage 60 min", price: "$159" },
      { duration: "Deep Tissue Hot Stone Massage 90 min", price: "$220" },
      { duration: "Cupping Therapy 60 min", price: "$135" },
      { duration: "Deep Tissue Therapy 60 min", price: "$135" },
      { duration: "Deep Tissue Therapy 75 min", price: "$169" },
      { duration: "Deep Tissue Therapy 90 min", price: "$189" },
      { duration: "Hot Stone Massage 60 min", price: "$135" },
      { duration: "Pre-Post Natal 60 min", price: "$115" },
      { duration: "Home Service", price: "Available - Contact for pricing" }
    ],
    hasPricing: true
  },
  {
    id: 2,
    name: "Physiotherapy",
    description: "Evidence-based physiotherapy treatments to help you recover from injuries, manage chronic pain, and improve mobility. Our experienced physiotherapists create personalized treatment plans.",
    icon: "Activity",
    pricing: [
      { duration: "Physiotherapy Assessment 45 min", price: "$110" },
      { duration: "Extended Physiotherapy 60 min", price: "$155" },
      { duration: "Follow up 30 min", price: "$80" },
      { duration: "Initial Pediatric 45 min", price: "$135" },
      { duration: "Initial Pediatric 30 min", price: "$90" },
      { duration: "Extended Pediatric Follow up 60 min", price: "$110" }
    ],
    hasPricing: true
  },
  {
    id: 3,
    name: "Osteopathy",
    description: "Holistic manual therapy focusing on the musculoskeletal system. Our osteopaths treat the body as a whole to restore balance and promote natural healing.",
    icon: "User",
    pricing: "Contact for pricing",
    hasPricing: false
  },
  {
    id: 4,
    name: "Acupuncture",
    description: "Traditional Chinese medicine technique using fine needles to stimulate specific points on the body, promoting natural healing and pain relief.",
    icon: "Target",
    pricing: "Contact for pricing",
    hasPricing: false
  },
  {
    id: 5,
    name: "Chiropractic",
    description: "Professional chiropractic care to address spinal misalignments, improve nervous system function, and enhance overall health and wellness.",
    icon: "Zap",
    pricing: "Contact for pricing",
    hasPricing: false
  }
];

export const whyChooseUs = [
  {
    title: "New & Modern Facility",
    description: "State-of-the-art clinic with the latest equipment and comfortable treatment rooms designed for your wellness journey.",
    icon: "Building"
  },
  {
    title: "Certified Professionals",
    description: "All our practitioners are fully certified and licensed, bringing expertise and professional care to every treatment.",
    icon: "Award"
  },
  {
    title: "Experienced Staff",
    description: "Our team has years of combined experience helping patients recover, heal, and achieve their wellness goals.",
    icon: "Users"
  },
  {
    title: "Direct Insurance Billing",
    description: "We provide direct billing to your insurance company for your convenience, making the process seamless and hassle-free.",
    icon: "CreditCard"
  }
];

// Mock function to handle booking submissions (will be replaced with backend)
export const mockBookingSubmission = (bookingData) => {
  console.log("Mock Booking Submission:", bookingData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Booking request received! We'll contact you shortly to confirm your appointment.",
        bookingId: Math.random().toString(36).substr(2, 9)
      });
    }, 1000);
  });
};

// Generate available time slots for booking
// Operating hours: Monday to Sunday, 10:00 AM - 7:00 PM
export const generateTimeSlots = () => {
  const slots = [];
  for (let hour = 10; hour <= 19; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      if (hour === 19 && minute > 0) break; // Stop at 7:00 PM
      const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      const period = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
      const displayTime = `${displayHour}:${minute.toString().padStart(2, '0')} ${period}`;
      slots.push({ value: time, label: displayTime });
    }
  }
  return slots;
};
